var include_shop_new = `
<div class="add">
	<div class="add-header">
		<p class="add-header__title">NEW!</p>
		<p class="add-header__text">nanacoが使えるようになりました ♪</p>
	</div>
	<div class="add-content">
		<ul class="add-list">
			<li class="add-list__item">
				<a href="#xebio" class="add-list__wrap js-sote_anchor Nanaco_StoreSearchNew">
					<div class="add-list__thumbnail"><img src="/material/img/common/logo/logo_xebio.png" alt="スーパースポーツゼビオ"></div>
					<p class="add-list__text">スーパースポーツゼビオ</p>
				</a>
			</li>
			<li class="add-list__item">
				<a href="#xebio_ex" class="add-list__wrap js-sote_anchor Nanaco_StoreSearchNew">
					<div class="add-list__thumbnail"><img src="/material/img/common/logo/logo_xebio_ex.png" alt="ゼビオスポーツエクスプレス"></div>
					<p class="add-list__text">ゼビオスポーツエクスプレス</p>
				</a>
			</li>
			<li class="add-list__item">
				<a href="#victoria" class="add-list__wrap js-sote_anchor Nanaco_StoreSearchNew">
					<div class="add-list__thumbnail"><img src="/material/img/common/logo/logo_victoria.png" alt="ヴィクトリア"></div>
					<p class="add-list__text">ヴィクトリア</p>
				</a>
			</li>
			<li class="add-list__item">
				<a href="#victoria_golf" class="add-list__wrap js-sote_anchor Nanaco_StoreSearchNew">
					<div class="add-list__thumbnail"><img src="/material/img/common/logo/logo_victoria_golf.png" alt="ヴィクトリアゴルフ"></div>
					<p class="add-list__text">ヴィクトリアゴルフ</p>
				</a>
			</li>
			<li class="add-list__item">
				<a href="#l_breath" class="add-list__wrap js-sote_anchor Nanaco_StoreSearchNew">
					<div class="add-list__thumbnail"><img src="/material/img/common/logo/logo_l_breath.png" alt="エルブレス"></div>
					<p class="add-list__text">エルブレス</p>
				</a>
			</li>
		</ul>
	</div>
</div>
`;
